export const calendarSrc =
  'https://web-assets-p-endpoint.azureedge.net/assets/img/ss_pacing_calendarillustration.png'
